import { Stack } from "@mui/material";
import { Icon, type IconName } from "components/Icon";

type EnergyAnalysisSectionTitleProps = {
  iconName: IconName;
  title: string;
};

export const EnergyAnalysisSectionTitle = ({ iconName, title }: EnergyAnalysisSectionTitleProps) => (
  <Stack className="items-center gap-2">
    <Icon iconName={iconName} size="sm" />
    <h3 className="font-ds-headline-md text-lds-foreground-heading-active">{title}</h3>
  </Stack>
);
